import * as TabPrimitive from '@headlessui/react';

import { cn } from '../../utils/cn';
import { Badge, BadgeProps } from '../Badge';
import { Text } from '../Text';

export function TabList({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <TabPrimitive.TabList
      className={cn(
        'flex gap-6 border-b border-secondary text-ls-black',
        className
      )}
    >
      {children}
    </TabPrimitive.TabList>
  );
}

export function TabLabel({
  label,
  badgeProps,
  className,
  disabled,
  dataTestId,
  onClick,
  onBlur,
}: {
  label: string;
  badgeProps?: BadgeProps;
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  onClick?: () => void;
  onBlur?: () => void;
}) {
  return (
    <TabPrimitive.Tab
      onClick={onClick}
      onBlur={onBlur}
      className={cn(
        'group flex items-center gap-2 border-b-2 border-b-transparent pb-5 text-tertiary outline-none transition-colors',
        'text-primary data-[selected]:border-b-[var(--text-primary)]',
        'hover:border-b-[var(--brand-500)] hover:text-[var(--brand-500)] data-[selected]:hover:border-b-[var(--brand-500)]',
        'disabled:cursor-default disabled:text-disabled disabled:hover:border-b-transparent',
        className
      )}
      disabled={disabled}
      data-testid={dataTestId}
    >
      <Text
        variant="md"
        className="font-normal group-data-[selected]:font-medium"
      >
        {label}
      </Text>
      {badgeProps && <Badge {...badgeProps} />}
    </TabPrimitive.Tab>
  );
}

export const TabPanels = TabPrimitive.TabPanels;

export const TabGroup = TabPrimitive.TabGroup;

export function TabPanel({
  children,
  className,
  panelRef,
  onScroll,
}: {
  children: React.ReactNode;
  className?: string;
  panelRef?: React.RefObject<HTMLDivElement>;
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
}) {
  return (
    <TabPrimitive.TabPanel
      className={cn('outline-none', className)}
      onScroll={onScroll}
      ref={panelRef}
    >
      {children}
    </TabPrimitive.TabPanel>
  );
}
